window.addEventListener('message', event => {
    //Pour l'instant-t qui est chargé dans une iframe : on redimensionne l'iframe en fonction de la taille du navigateur (renvoyé par React)
    //Source : https://javascriptbit.com/transfer-data-between-parent-window-and-iframe-postmessage-api/
    let iframeElement = document.querySelector( '.js-instant-t-iframe' );
    if(iframeElement != null) {
        if (event.origin.includes('ml-autodiag.staging-002.internetrama.net') || event.origin.includes('instant-t.missionslocalesnormandie.fr')) {
            if(event.data.width != null && event.data.height != null) {
                console.log('width', event.data.width);
                console.log('height', event.data.height);
                iframeElement.style.width  = event.data.width + 'px';
                iframeElement.style.height = event.data.height + 'px';
            }
        }
    }
});